<!--
  * @Author: changyunxia
  * @Date:2020年10月15日 16:33:10
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月15日 16:33:10
  * @Description: 参会人标签
  * @FilePath:@/components/meetingUserList.vue
-->
<template>
  <div class="user_list">
    <!-- <div class="tit">选择参会人</div> -->

    <ul>
      <li :style="{ 'margin-left': [close==true?'10px':'5px'],'padding': [close==true? '3px 5px':'2px 2px'],'font-size': [close==true? '12px':'10px']} " v-for="(item, index) in userList" :key="index">
        <div v-if="close"><van-icon name="clear" class="icon-bg" @click="delFunc(item)" /></div>
        <span>{{ item.text }}</span>
      </li>
      <li :style="{ 'margin-left': [close==true?'10px':'5px'],'padding': [close==true? '3px 5px':'2px 2px'] }" v-if="plus" @click="$emit('update:showPicker', true)">
        <van-icon name="plus" class="plus" />
      </li>
    </ul>

  </div>
</template>

<script>

export default {
  name: 'MeetingUserList',
  components: {},
  props: {
    userList: {
      type: Array,
      default: null
    },
    plus: {
      type: Boolean,
      default: null
    },
    close: {
      type: Boolean,
      default: null
    }

  },
  data() {
    return {

    }
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {
    delFunc(val) {
      this.userList.map((item, i) => {
        if (item === val) {
          this.userList.splice(i, 1)
          // 在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
          return true
        }
      })
      this.$emit('delFunc', val)
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.icon-bg{
        color: #f33939;
    font-size: 15px;
}
.plus{
    font-size: 12px;
    color: #585858;
    width: 42px;
    line-height: 15px;
}
.user_list{
    background: #ffffff;
    .tit{
    color: #646566;
    font-size: 14px;
    padding: 16px 15px;
    }
    ul{
    margin-left: 7px;
    margin-right: 7px;
      height: auto;
      display: flex;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    //   justify-content: space-between;
    //   flex-direction: row;
    //   flex-wrap: wrap;
    //   margin: 0 15px;
    // &:nth-child(1){

    // }
      li{
             position: relative;
            border: 1px solid #e8e6e6;
            border-radius: 3px;
            /* width: 42px; */
            /* height: 23px; */
            /* line-height: 26px; */
            background: #f2f2f2;
            // font-size: 12px;
            text-align: center;
            margin-bottom: 8px;
            color: #806c6c;
            // margin-left: 10px;
            //padding: 3px 5px;
          &>div{
            display: block;
            position: absolute;
            top: -8px;
            right: -7px;

          }

      }
    }
}
</style>
